import React, { useEffect, useRef, useState } from 'react';
import Button from "@material-ui/core/Button";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FormControl from "@material-ui/core/FormControl";
import { FastField, Field, Form, Formik, useFormikContext } from "formik";
import ModalChangeCalendar from "../common/Modals/ModalChangeCalendar";
import StickyBottomButton from "../common/StickyBottomButtonSave/StickyBottomButton";
import { usePrevious } from "../common/CustomHook/usePrevious";
import DateRangePickerComponent from "../common/DateRangePickerComponent/DateRangePickerComponent";
import AutoSaveWithDebounce from "../common/Autosave/AutoSaveWithDebounce";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import Collapse from "@material-ui/core/Collapse";
import { themeButtons } from "../../css/themeButtons";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import Box from "@material-ui/core/Box";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import AddIcon from '@material-ui/icons/Add'
import Preloader from "../common/Preloader/Preloader";
import { useMediaQuery } from "@material-ui/core";
import Month from "../common/CalendarPieces/Month";
import { NavLink, useHistory } from "react-router-dom";
import DeleteIcon from "@material-ui/icons/Delete";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import Modal from "../common/Modals/Modal";


//Рендер вехней части страницы с инструкцией и местом по доп кнопки
const RenderSettingsMenu = ({
  ratePlans,
  rooms,
  roomId,
  ratePlan,
  updateRatePlan,
  objectId,
  priceTypes,
  priceType,
  changePriceType
}) => {
  const mobileAgent = useMediaQuery('(max-width: 974px)');
  let history = useHistory();
  const [showInstruction, setShowInstruction] = useState(false);
  const toggleShowInstruction = () => {
    setShowInstruction(!showInstruction)
  }


  const [expanded, setExpanded] = useState(false);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const onSubmit = (values) => {
    if (values.room !== roomId) {

      history.push(`/lk/${objectId}/calendar/${values.room}`)
    }
    if (values.rate !== ratePlan) {
      updateRatePlan(values.rate)
    }
    if (values.priceType !== priceType) {
      changePriceType(Number(values.priceType))
    }
    setExpanded(false)
  }

  const buttons = themeButtons()
  if (!ratePlans && !rooms) {
    return <Preloader loading={true}/>
  }
  return (
    <div id="settings-menu">
      <div className="container-fluid">
        <Formik initialValues={{ room: roomId, rate: ratePlan, priceType: priceType ? priceType : '334' }}
                enableReinitialize
                onSubmit={onSubmit}>
          {({ values, setFieldValue }) => (
            <Form>
              <div className="d-flex flex-wrap">
                <Button className="d-lg-none px-3 py-2"
                        startIcon={<FontAwesomeIcon icon={"ellipsis-v"}/>}
                        type="button"
                        onClick={handleExpandClick}>
                  Выбрать номер
                </Button>
                <div className="select-room-month d-none d-lg-flex flex-row me-2">
                  <div className="row g-1 pb-1">
                    <div className="col-sm-auto">
                      <FastField name="room">
                        {({ field }) => (
                          <FormControl variant="outlined" size="small" fullWidth
                                       className="long-select">
                            <InputLabel>Номер</InputLabel>
                            <Select
                              label="Номер"
                              {...field}
                            >
                              {rooms && rooms.map(room => {
                                return <MenuItem key={room.id} value={room.id}>
                                  {room.name}
                                </MenuItem>
                              })}


                            </Select>
                          </FormControl>
                        )}
                      </FastField>
                    </div>
                    <div className="col-sm-auto">
                      <FastField name="rate">
                        {({ field }) => (
                          <FormControl variant="outlined" size="small" fullWidth
                                       className="long-select">
                            <InputLabel>Тариф</InputLabel>
                            <Select
                              label="Тариф"
                              {...field}
                            >
                              {ratePlans && ratePlans.map((rate) => {
                                return <MenuItem key={rate.id} value={rate.id}>
                                  {rate.name}
                                </MenuItem>
                              })}
                            </Select>
                          </FormControl>
                        )}
                      </FastField>
                    </div>
                    <div className="col-sm-auto">
                      <Field name="priceType">
                        {({ field }) => {
                          return <FormControl variant="outlined"
                                              size="small"
                                              onClick={(event) => event.stopPropagation()}
                                              onFocus={(event) => event.stopPropagation()}>

                            <InputLabel>Тип цены</InputLabel>


                            <Select {...field}
                                    label="Тип цены">
                              {priceTypes && Object.keys(priceTypes).map(id =>
                                <MenuItem key={id} value={String(id)}>
                                  {priceTypes[id]}
                                </MenuItem>
                              )}


                            </Select>
                          </FormControl>
                        }}
                      </Field>
                    </div>
                  </div>
                </div>
                <Box className="instruction" onClick={toggleShowInstruction}>
                  <span className="instruction__text">Инструкция</span>
                  <IconButton>
                    <FontAwesomeIcon icon={["far", "question-circle"]}/>
                  </IconButton>
                </Box>
              </div>
              <Collapse in={mobileAgent && expanded} timeout="auto" unmountOnExit>
                <div className="select-room-month-mobile">
                  <div className="row g-3 pb-3">
                    <div className="col-12">
                      <FastField name="room">
                        {({ field }) => (
                          <FormControl variant="outlined" size="small" fullWidth
                                       className="long-select">
                            <InputLabel>Номер</InputLabel>
                            <Select
                              label="Номер"
                              {...field}
                            >
                              {rooms && rooms.map(room => {
                                return <MenuItem key={room.id} value={room.id}>
                                  {room.name}
                                </MenuItem>
                              })}


                            </Select>
                          </FormControl>
                        )}
                      </FastField>
                    </div>
                    <div className="col-12">
                      <FastField name="rate">
                        {({ field }) => (
                          <FormControl variant="outlined" size="small" fullWidth
                                       className="long-select">
                            <InputLabel>Тариф</InputLabel>
                            <Select
                              label="Тариф"
                              {...field}
                            >
                              {ratePlans && ratePlans.map((rate) => {
                                return <MenuItem key={rate.id} value={rate.id}>
                                  {rate.name}
                                </MenuItem>
                              })}
                            </Select>
                          </FormControl>
                        )}
                      </FastField>
                    </div>
                    <div className="col-12">
                      <Field name="priceType">
                        {({ field }) => {
                          return <FormControl variant="outlined"
                                              size="small"
                                              className="long-select w-100"
                                              onClick={(event) => event.stopPropagation()}
                                              onFocus={(event) => event.stopPropagation()}>

                            <InputLabel>Тип цены</InputLabel>


                            <Select {...field}
                                    label="Тип цены">
                              {priceTypes && Object.keys(priceTypes).map(id =>
                                <MenuItem key={id} value={String(id)}>
                                  {priceTypes[id]}
                                </MenuItem>
                              )}

                            </Select>
                          </FormControl>
                        }}
                      </Field>
                    </div>

                    <div className="col-12 text-center">
                      <Button className={`btn ${buttons.btnGreen}`} type="submit">Выбрать</Button>
                    </div>
                  </div>

                </div>
              </Collapse>
              {!mobileAgent && <AutoSaveWithDebounce debounceMs={10}/>}

            </Form>)}
        </Formik>

      </div>


      <Modal toggleShow={toggleShowInstruction} show={showInstruction}
             title={"Инструкция:"}
             textBtnOk={"Понятно"}>
        <Typography variant="body1" gutterBottom>
          <b>1. Выбор номера для редактирования.</b> Нажмите на кнопку "Номер" в верхней части экрана. В
          выпадающем списке выберите номер для
          редактирования;
        </Typography>
        <Typography variant="body1" gutterBottom>
          <b>2. Выбор тарифа для редактирования.</b> Нажмите на кнопку "Тариф" в верхней части экрана. В
          выпадающем списке выберите Тариф для
          редактирования;
        </Typography>
        <Typography variant="body1" gutterBottom>
          <b>3. Выбор периода для редактирования.</b> Необходимо нажать на две даты в календаре, первая будет
          началом, вторая - окончанием периода. После, нажмите кнопку редактировать в нижней части экрана;
        </Typography>
        <Typography variant="body1" gutterBottom>
          <b>4. Добавление типа размещения.</b> После того как Вы выбрали период и нажали кнопку
          "Редактировать" в правой части экрана появится блок с редактированием цен на выбранный период.
          В этом блоке Вы можете добавить тип размещения, в нижней части нажмите "Добавить тип размещения" и
          выберите новый тип размещения;
        </Typography>
        <Typography variant="body1" gutterBottom>
          <b>5. Редактирование цены номера.</b> После того как Вы выбрали период и нажали кнопку
          "Редактировать" в правой части экрана появится блок с редактированием цен на выбранный период.
          В этом блоке Вы можете изменить цену на весь выбранный период и тип размещения, просто введите сумму
          напротив типа размещения(выделено жирным).
          Так же Вы можете изменить цену отдельно на любой день из выбранного периода. Для этого надо
          нажать на кнопку "По дням" и Вам будет открыт список цен на каждый день выбранного
          периода;
        </Typography>
        <Typography variant="body1" gutterBottom>
          <b>6. Активность продаж.</b> В окне редактирования цен номера есть возможность закрыть или открыть
          активность продаж на выбранные даты. При закрытии активности продаж цены в календаре остаются, но
          бронирования для туристов не доступно;
        </Typography>
        <Typography variant="body1" gutterBottom>
          <b>7. Сохранение изменений.</b> После того как Вы задали нужные значения в блоке редактирования
          цен (прим. п.4), нажмите кнопку "Сохранить" в нижней части данного блока;
        </Typography>

      </Modal>
    </div>
  )
}

//блок цены, из модалки редактирования цены
const RenderPriceBlock = React.memo((props) => {
  const {
    persone,
    priceLines,
    expandedPrices,
    handleChangeExpendedPrices,
    updateInitValue,
    updatePeriodPrice,
    closeAccordion,
    removeTypeOfAllocation
  } = props

  const [changePeriod, setChangePeriod] = useState(false)

  //контек формы, беру валуе и методы обновления филда и получения филда(можно сделать без получения филда, через валуе, добавил т.к. тестировал по разному)
  const { values, setFieldValue } = useFormikContext();


  const prevPeriodPrice = usePrevious(values && values[persone]?.periodPrice)

  useEffect(() => {
    if (values && values[persone] && values[persone].periodPrice && prevPeriodPrice !== values[persone]?.periodPrice && changePeriod) {
      //если цена в филде периода дат не совпадает с предидущей ценой в этом филде и не равна пустой строке то заходим в условие
      updatePeriodPrice(persone, values)

    }
  }, [values && values[persone]?.periodPrice])

  //еффект изменение цены на период дат
  useEffect(() => {
    if (values && values[persone]) {
      let uniqValues = new Set(Object.values(values[persone]))
      if (prevPeriodPrice === values[persone]?.periodPrice && !changePeriod && uniqValues.size > 1) {
        //если цена в филде периода дат не совпадает с предидущей ценой в этом филде и не равна пустой строке то заходим в условие
        setFieldValue(`${persone}.periodPrice`, '')
      }
    }

  }, [values])


  let prevExpendedPrice = usePrevious(expandedPrices)
  useEffect(() => {
    if (persone === expandedPrices) {
      updateInitValue(persone, values)
    }
    if (!expandedPrices && persone == prevExpendedPrice) {
      updateInitValue(persone, values, "close")
    }
  }, [expandedPrices])


  let personeSwitch = (persone) => {
    switch (persone) {
      case 'dop':
        return 'доп. место'
        break
      case 'child':
        return 'детское место'
        break
      case '1':
        return '1 гость'
        break
      default:
        return `до ${persone} гостей`
        break
    }
  }

  const buttons = themeButtons()
  return (
    <div className="body__price-block">
      <div className="row gx-2 price-block-header">
        <div className="col-5">

          <div className="text">
            {personeSwitch(persone)}
          </div>


        </div>
        <div className="col-7">
          <div className="control">
            <FastField name={`${persone}.periodPrice`}>
              {({ field, form }) => (
                <FormControl className="picker form-control" variant="outlined" size="small">
                  <OutlinedInput
                    {...field}
                    type="number"
                    onBlur={() => setChangePeriod(false)}
                    onFocus={() => {
                      closeAccordion()
                      setChangePeriod(true)
                    }}

                    endAdornment={<InputAdornment position="end">₽</InputAdornment>}
                  />
                </FormControl>
              )}
            </FastField>

            <IconButton className="p-1 ms-1" onClick={() => removeTypeOfAllocation(persone)}>
              <DeleteIcon fontSize="small"/>
            </IconButton>
          </div>

        </div>
        <div className="col-12">
          <span className="text-muted small">Цена номеров на выбранные даты</span>
        </div>
      </div>
      <Button className={`btn w-100 ${buttons.btnLight}`}
              onClick={() => handleChangeExpendedPrices(persone)}>
        По дням
        {expandedPrices === persone
          ? <FontAwesomeIcon icon={"chevron-up"} className="ms-1"/>
          : <FontAwesomeIcon icon={"chevron-down"} className="ms-1"/>
        }
      </Button>
      <Collapse className="mt-3" in={expandedPrices === persone} timeout="auto" unmountOnExit>

        {priceLines && Object.keys(priceLines).filter(item => item !== 'periodPrice').map((date) => {
            return <RenderPriceLine key={date} date={date} persone={persone}/>
          }
        )}


      </Collapse>

    </div>
  )
})

//линия цены в блоке цены, из модалки редактирования цены
const RenderPriceLine = React.memo(({ date, persone }) => {
  const { setFieldValue } = useFormikContext();


  return (
    <div className="price-list__item">
      <div className="row gx-2">
        <div className="col-5">

          <div className="text">
            {date.split("-").reverse().join(".")}
          </div>


        </div>
        <div className="col-7">
          <div className="control">
            <FastField name={`${persone}.${date}`}>
              {({ field, form }) => (
                <FormControl className="picker form-control" variant="outlined" size="small">
                  <OutlinedInput
                    {...field}
                    type="number"
                    endAdornment={<InputAdornment position="end">₽</InputAdornment>}
                  />
                </FormControl>
              )}
            </FastField>
            <IconButton className="p-1 ms-1" onClick={() => setFieldValue(`${persone}.${date}`, '')}>
              <DeleteIcon fontSize="small"/>
            </IconButton>
          </div>
        </div>
      </div>
    </div>
  )
})

const AddTypeOfAllocationModal = ({ onClose, open, types }) => {

  const handleClose = () => {
    onClose();
  };

  const handleListItemClick = (value) => {
    onClose(value);
  };

  let typeSwitch = (type) => {
    switch (type) {
      case 'dop':
        return 'доп. место'
        break
      case 'child':
        return 'детское место'
        break
      case '1':
        return '1 гость'
        break
      default:
        return `до ${type} гостей`
        break
    }
  }


  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Добавить тип размещения</DialogTitle>
      <List sx={{ pt: 0 }}>
        {types && types.map(type => {
          return <ListItem key={type} autoFocus button onClick={() => handleListItemClick(type)}>
            <ListItemAvatar>
              <Avatar>
                <AddIcon/>
              </Avatar>
            </ListItemAvatar>
            {typeSwitch(type)}
          </ListItem>
        })}
      </List>
    </Dialog>
  );
}


//основной компонент коммиссионого календаря
const CalendarPercent = (props) => {
  const {
    ratePlans, rooms, roomId, objectId, ratePlan, getPrices,
    roomName, maxTypeBD, updateRatePlan, priceId,
    types, updatePrices, updateSalesActive, salesActiveId, salesActiveClose,
    channelManagerId, channelManagerLink, priceType, priceTypes, getPriceTypes
  } = props


  const [dates, setDates] = useState()
  const [months, setMonths] = useState()
  const [show, setModalShow] = useState(false);
  const [startRangeDate, setStartRangeDate] = useState(null)
  const [endRangeDate, setEndRangeDate] = useState(null)
  const [dateRange, setDateRange] = useState("")
  const [pricesBlock, setPricesBlock] = useState("")
  const [initialValuesByPeriod, setInitialValuesByPeriod] = useState()
  const [dontExistingAllocation, setDontExistingAllocation] = useState()
  const [lastDate, setLastDate] = useState()
  const [deletedPricesBlock, setDeletedPricesBlock] = useState({})
  const [btnChangeActivity, setBtnChangeActivity] = useState("close")
  const [showAdditionSettings, setShowAdditionSettings] = useState(false)

  const soloPricesTypes = [333, 5186, 5187]

  let maxType = soloPricesTypes.includes(priceType) ? 1 : maxTypeBD

  useEffect(() => {
    if (!priceTypes) {
      getPriceTypes()
    }
  }, [])


  useEffect(() => {
    setDates(false)
    getPrices({ object: objectId, room: roomId, ratePlan: ratePlan })
  }, [roomId, ratePlan])


  useEffect(() => {
    if (dates !== props.dates) {
      setDates(props.dates)
    }
  }, [props.dates])


  //открытие/закрытие модалок
  const toggleShowPriceModal = (showStatus) => {
    setModalShow(showStatus)
  };

  //после получения цен готовим их к рендеру
  useEffect(() => {
    if (dates) {
      let months = []
      let yearMonth = []

      //получаем год и месяц каждой цены
      Object.keys(dates).map((key) => {
        yearMonth.push(key.slice(0, 7))
      })

      //выбираем только уникалыный год/месяц
      let uniqueYearMonth = [...new Set(yearMonth)]

      //получаем массивы дат всех месяцев
      let monthDates = []
      for (let i = 0; i < uniqueYearMonth.length; i++) {
        monthDates.push(Object.keys(dates).filter((date) => date.slice(0, 7) === uniqueYearMonth[i]))
      }

      //делаем объекты месяцев с полными данным по ценам
      for (let i = 0; i < monthDates.length; i++) {
        let month = {}
        monthDates[i].map((date) => month = { ...month, [date]: dates[date] })
        months.push(month)
      }

      setLastDate(Object.keys(dates)[Object.keys(dates).length - 1])
      //сетаем в стейт массив с объектами по месяцам
      setMonths(months)
    }
  }, [dates])


  //выбор начальной и конечной дат диапазона
  const selectDate = (date) => {

    toggleShowPriceModal(false)

    //если нет начальной даты периода то устанавливаем ее, в противном случае установливаем  установливаем конечную дату периода
    if (!startRangeDate) {
      setStartRangeDate(date)
      setEndRangeDate(date)
    } else {
      //если начальная дата диапазона меньше новой пришедшей из параметра, то добавляем новую дату в конец диапазона
      //в противном случае дату начала диапозона добавляем в конец, а дату из параметра устанавливаем датой начала диапазона
      if (new Date(startRangeDate).getTime() < new Date(date).getTime()) {
        setEndRangeDate(date)
      } else {
        setEndRangeDate(startRangeDate)
        setStartRangeDate(date)
      }
    }

    //(if) Если выбрана 2 или меньше дат то в объект даты добавляем свойство selected.
    //(else) Или если в объекте дат, больше 2х дат с атрибутом selected, тогда удаляем у всех свойство selected,
    // устанавливаем выбранную дату начальной и устанавливаем свойство selected, удаляем конечную дату периода.
    if (Object.values(dates).filter(date => date.selected === true).length <= 1) {
      setDates({ ...dates, [date]: { ...dates[date], selected: true } })
    } else {
      let newDates = { ...dates }
      Object.keys(dates).map((key) => newDates = { ...newDates, [key]: { ...dates[key], selected: false } })
      setStartRangeDate(date)
      setEndRangeDate(date)
      setDates({ ...newDates, [date]: { ...dates[date], selected: true } })
    }
  }

  //эфект изменения начальной и конечной дат периода
  useEffect(() => {
    if (startRangeDate && endRangeDate) {


      //получаем индекс начальной даты периода в общем объекте дат
      let startRangeIndex = Object.keys(dates).indexOf(startRangeDate)
      //получаем индекс конечной даты периода в общем объекте дат
      let finishRangeIndex = Object.keys(dates).indexOf(endRangeDate)

      //даты входящие в диапазон между начальной и конечной датой периода
      let datesRange = []

      //берем количесво дат равное разности старшей по индексу и младшей по индексу дат, и перебираем ключи дат начиная от младшего по индексу
      if (finishRangeIndex > startRangeIndex) {
        for (let i = 0; i <= finishRangeIndex - startRangeIndex; i++) {
          datesRange.push(Object.keys(dates)[startRangeIndex + i])
        }
      } else {
        for (let i = 0; i <= startRangeIndex - finishRangeIndex; i++) {
          datesRange.push(Object.keys(dates)[finishRangeIndex + i])
        }
      }

      //устанавливаем в стейт диапазон выбранных дат
      setDateRange(datesRange)

      //т.к setState запрещено делать в цикле, присваем первичный объект дат переменной, в цикле перебираем даты периода и устанавливаем им свойтво selected: true
      let newDates = { ...dates }
      Object.keys(dates).map((key) => newDates = { ...newDates, [key]: { ...dates[key], selected: false } })
      datesRange.map((date) => newDates = { ...newDates, [date]: { ...newDates[date], selected: true } })

      if (salesActiveClose && datesRange.every(date => salesActiveClose.includes(date))) {
        setBtnChangeActivity("open")
      } else if (salesActiveClose && datesRange.some(date => salesActiveClose.includes(date))) {
        setBtnChangeActivity("all")
      } else {
        setBtnChangeActivity("close")
      }


      //перезаписываем начальный объект с датами
      setDates(newDates)
    }

  }, [startRangeDate, endRangeDate])


  useEffect(() => {
    if (dateRange) {

      let priceBlock = {}


      let longerTypesList = dateRange.map(date => dates[date].price)
        .reduce((prev, current, i, arr) => prev.length > current.length ? prev : current)
        .map(item => item.type)

      longerTypesList.map(type => {
        priceBlock = {
          ...priceBlock,
          [type]: { ...priceBlock[type] }
        }
      })

      dateRange.map(date => {
        longerTypesList.map(type => {
          let filtredType = dates[date].price.filter(item => item.type === type)

          priceBlock = {
            ...priceBlock,
            [type]: {
              ...priceBlock[type],
              [date]: filtredType.length !== 0 ? filtredType[0].value : undefined
            }
          }
        })
      })

      setPricesBlock(priceBlock)

      let initValueByPeriod = {}
      Object.keys(priceBlock).map(persone => {
        let filtredPrices = new Set(Object.values(priceBlock[persone]))
        if (filtredPrices.size === 1) {
          initValueByPeriod = {
            ...initValueByPeriod,
            [persone]: { ...initValueByPeriod[persone], periodPrice: [...filtredPrices][0] }
          }
        } else {
          initValueByPeriod = {
            ...initValueByPeriod,
            [persone]: { ...initValueByPeriod[persone], periodPrice: "" }
          }

        }
      })

      setInitialValuesByPeriod(initValueByPeriod)

      let dontExistingAllocationLocal = []
      for (let i = 1; i <= maxType; i++) {
        if (!priceBlock.hasOwnProperty(i)) {
          dontExistingAllocationLocal.push(i)
        }
      }
      if (!priceBlock.hasOwnProperty('dop')) {
        dontExistingAllocationLocal.push('dop')
      }
      if (!priceBlock.hasOwnProperty('child')) {
        dontExistingAllocationLocal.push('child')
      }

      setDontExistingAllocation(dontExistingAllocationLocal)
    }
  }, [dateRange])


  //состояние и контроль аккордиона
  const [expandedPrices, setExpandedPrices] = useState(false);
  const handleChangeExpendedPrices = (persone) => {
    setExpandedPrices(persone === expandedPrices ? false : persone);
  };


  //обновление цены на выбранный период
  const updatePeriodPrice = (persone, formValue) => {
    let newInitValue = { ...formValue }

    //устанавливаеем новые значения цен во все даты периода
    Object.keys(newInitValue[persone]).map(item => {
      newInitValue = {
        ...newInitValue,
        [persone]: { ...newInitValue[persone], [item]: formValue[persone]["periodPrice"] }
      }
    })

    //состовляем новые блоки цены на период, с установкой цены на все даты периода
    let newPriceBlock = { ...pricesBlock }
    dateRange.map(date => {
      newPriceBlock = {
        ...newPriceBlock,
        [persone]: { ...newPriceBlock[persone], [date]: newInitValue[persone]["periodPrice"] }
      }
    })


    //сетаем в стейт новый инициалВалуе для цен, и новые блоки цен периода
    setPricesBlock(newPriceBlock)
    setInitialValuesByPeriod(newInitValue)
  }

  //состовление цен по дням из цены за период
  const updateInitValue = (persone, formValue, type) => {


    let newInitValue = { ...formValue }

    if (type !== "close") {
      if (Object.keys(pricesBlock[persone]).length !== dateRange.length) {
        dateRange.map(date => {
          newInitValue = {
            ...newInitValue,
            [persone]: {
              ...newInitValue[persone],
              [date]: pricesBlock[persone][date] ? pricesBlock[persone][date] : undefined
            }
          }
        })
      } else {
        newInitValue = {
          ...newInitValue,
          [persone]: { ...newInitValue[persone], ...pricesBlock[persone] }
        }
      }
    } else {
      let newPriceBlock = { ...pricesBlock }

      dateRange.map(date => {
        newPriceBlock = {
          ...newPriceBlock,
          [persone]: { ...newPriceBlock[persone], [date]: formValue[persone][date] }
        }
      })

      newInitValue[persone] = { ...newPriceBlock[persone], periodPrice: formValue[persone]["periodPrice"] }

      setPricesBlock(newPriceBlock)


    }


    setInitialValuesByPeriod(newInitValue)
  }


  //autosubmit dates to ModalChangeCalendar
  const updateDates = (values) => {
    if (values.dates) {
      for (let i = 0; i < values.dates.length; i++) {
        if (values.dates[0] && values.dates[1]) {
          setStartRangeDate(new Date(values.dates[0]).toLocaleDateString('ru-RU').split(".").reverse().join("-"))
          setEndRangeDate(new Date(values.dates[1]).toLocaleDateString('ru-RU').split(".").reverse().join("-"))
        }
      }
    }
  }

  const validateDatepicker = (values) => {
    let errors = {}

    let yesterday = new Date(new Date().setDate(new Date().getDate() - 1)).getTime()
    let maxDate = new Date(lastDate).getTime()
    let startDate = new Date(values.dates[0]).getTime()
    let finishDate = new Date(values.dates[1]).getTime()

    if (values.dates[0]?.toString() === "Invalid Date" || values.dates[1]?.toString() === "Invalid Date") {
      errors = { dates: "Некорректные даты" }
    }
    if (startDate < yesterday || finishDate < yesterday || startDate > maxDate || finishDate > maxDate) {
      errors = { dates: "Выбраны даты не входящие в календарь" }
    }
    if (finishDate < startDate) {
      errors = { dates: `Дата "от" не может быть меньше даты "до"` }
    }

    return errors
  }

  //закрытие модалки изменения цен
  const closeModalPrice = () => {
    setStartRangeDate(null)
    setEndRangeDate(null)

    let newDates = { ...dates }
    Object.keys(dates).map((date) => {
      delete newDates[date].selected
    })
    setDates(newDates)
    setInitialValuesByPeriod({})
    toggleShowPriceModal(false)
    setExpandedPrices(false)

  }


  //сабмит цен
  const onSubmitPrice = (values) => {

    closeModalPrice()
    let submitingPrice = {}

    let savedPrice = { ...pricesBlock }


    Object.keys(values).map(item => {
      dateRange.map(date => {
        savedPrice = {
          ...savedPrice,
          [item]: {
            ...savedPrice[item],
            [date]: values[item][date] || values[item][date] === '' ? values[item][date] : savedPrice[item][date]
          }
        }
      })
    })

    let allPrices = { ...deletedPricesBlock, ...savedPrice }

    Object.keys(allPrices).map(item => {
      dateRange.map(date => {
        if (allPrices[item][date] || allPrices[item][date] === '') {
          submitingPrice = {
            ...submitingPrice,
            [types[item]]: {
              ...submitingPrice[types[item]],
              [date]: ""
            }
          }
          submitingPrice = {
            ...submitingPrice,
            [types[item]]: {
              ...submitingPrice[types[item]],
              [date]: {
                ...submitingPrice[types[item]][date],
                price: allPrices[item][date],
                priceId: priceId[`${item}|${date}`]
              }
            }
          }
        }

      })
    })

    updatePrices({
      object: objectId,
      room: roomId,
      ratePlan: ratePlan,
      priceType: priceType,
      prices: JSON.stringify(submitingPrice)
    })


  }

  //реф формы цен
  const formRef = useRef()

  //переназначенный submit формы
  const pricesSubmiteHandler = (values) => {
    if (formRef.current) {
      formRef.current.handleSubmit()
    }
  }

  const [open, setOpen] = useState(false);

  const handleClickOpenAddTypeOfAllocation = () => {
    setExpandedPrices(false)
    setOpen(true);
  };

  const handleCloseAddTypeOfAllocation = (value) => {
    setOpen(false);
    addTypeOfAllocation(value)
  };

  const addTypeOfAllocation = (newAllocation) => {
    if (newAllocation) {
      let newPricesBlock = { ...pricesBlock }
      let newInitValue = { ...initialValuesByPeriod, [newAllocation]: { periodPrice: undefined } }

      dateRange.map(date => {
        newPricesBlock = {
          ...newPricesBlock,
          [newAllocation]: { ...newPricesBlock[newAllocation], [date]: undefined }
        }
      })

      setPricesBlock(newPricesBlock)
      setInitialValuesByPeriod(newInitValue)
      setDontExistingAllocation(dontExistingAllocation.filter(item => item !== newAllocation))
    }
  }

  const removeTypeOfAllocation = (type) => {

    let newPricesBlock = { ...pricesBlock }
    Object.keys(pricesBlock[type]).map(date => {
      newPricesBlock = { ...newPricesBlock, [type]: { ...newPricesBlock[type], [date]: '' } }
    })

    setDeletedPricesBlock({ ...deletedPricesBlock, [type]: newPricesBlock[type] })


    setDontExistingAllocation([...dontExistingAllocation, type])


    delete newPricesBlock[type]
    setPricesBlock(newPricesBlock)


    let newInitValue = { ...initialValuesByPeriod }
    delete newInitValue[type]
    setInitialValuesByPeriod(newInitValue)

  }

  //изменит активность продаж
  const changeActivitySale = async (type) => {

    closeModalPrice()

    let salesActive = {}
    dateRange.forEach((date) => {
      if (!salesActive[date]) {
        salesActive = { ...salesActive, [date]: {} }
      }
      salesActive = {
        ...salesActive,
        [date]: { active: type, activeId: salesActiveId[date] ? salesActiveId[date] : null }
      }

    })

    updateSalesActive({
      object: objectId,
      room: roomId,
      ratePlan: ratePlan,
      salesActive: JSON.stringify(salesActive)
    })


  }

  const changePriceType = (newPriceType) => {
    updatePrices({
      object: objectId,
      room: roomId,
      ratePlan: ratePlan,
      priceType: newPriceType,
      prices: {}
    })
  }

  if (!ratePlan) {
    return (
      <div className="container-fluid">
        <h6 className="w-100 text-center mt-5">
          На Вашем объекте пока не выбрано не одного тарифного плана <br/>
          <Link component={NavLink} to={`/lk/${objectId}/rate-plans`}>Перейти к добавлению</Link>
        </h6>
      </div>
    )
  }


  const buttons = themeButtons();
  if (!dates) {
    return <Preloader loading={true}/>
  }
  return (
    <>
      <RenderSettingsMenu ratePlans={ratePlans}
                          rooms={rooms}
                          roomId={roomId}
                          ratePlan={ratePlan}
                          changePriceType={changePriceType}
                          updateRatePlan={updateRatePlan}
                          objectId={objectId}
                          priceTypes={priceTypes}
                          priceType={priceType}/>
      <div className="container-fluid">
        {!!channelManagerId && <Box className="alert alert-danger">
          <Typography variant={"subtitle1"}>
            Вы используете менеджер каналов для управления доступностью и
            ценами.
          </Typography>
          {channelManagerLink ?
              <Typography variant={"subtitle1"}>
                Чтобы внести изменения,
                перейдите по ссылке: <Link href={channelManagerLink}>Изменить цены и
                доступность</Link>
              </Typography> : ''}
        </Box>}
        <div className="alert alert-warning">
          Выберите даты для редактирования
        </div>
        {/* TODO t#235782 - добавление моментального подтвержения

                    <div className="room-calendar__addition-setting">


                    <FormControlCheckBoxes
                        label={"Моментальное подтверждение"}
                        control={<GreenCheckbox/>}
                    />

                    <CustomTooltip
                        title={"Все поступающие бронирования будут автоматически подтверждаться. Выбирая этот пункт, убедитесь, что в календаре занятости Вы всегда вовремя указываете актуальное количество свободных номеров."}
                        arrow placement="top">
                        <span>
                            <FontAwesomeIcon className={"ms-1 room-calendar__addition-question"} icon={["far", "question-circle"]}/>
                         </span>
                    </CustomTooltip>

                </div>*/}

        <h5 className="d-lg-none">{roomName}</h5>
        <div className="room-calendar__table percentCalendar">
          <div className="room-calendar__table-period days">
            {months && months.map((month, index) => {

              return <Month key={index} month={month} selectDate={selectDate}/>
            })}
          </div>
        </div>


        <ModalChangeCalendar show={show}
                             btnSaveAction={pricesSubmiteHandler}
                             exitModal={closeModalPrice}
                             btnAddAllocationType={handleClickOpenAddTypeOfAllocation}
                             activitySale={true}
                             btnChangeActivity={btnChangeActivity}
                             changeActivitySale={changeActivitySale}
                             existAddTypes={dontExistingAllocation && dontExistingAllocation.length !== 0}
                             calendar="price">
          <div className="body__date">
            <div className="row gx-2">

              <Formik
                initialValues={{ dates: [startRangeDate, endRangeDate] }}
                validate={validateDatepicker}
                onSubmit={updateDates}
                enableReinitialize>
                {({ errors }) =>
                  <Form>
                    <DateRangePickerComponent
                      name="dates"
                      startText="Дата заезда, от"
                      endText="Дата заезда, до"
                      disablePast={true}
                      maxDate={new Date(lastDate)}
                      error={Boolean(errors.dates)}
                      helperText={errors.dates}
                    />
                    <AutoSaveWithDebounce debounceMs={100}/>
                  </Form>
                }

              </Formik>

            </div>
          </div>

          <Formik
            innerRef={formRef}
            initialValues={initialValuesByPeriod}
            enableReinitialize
            onSubmit={onSubmitPrice}>
            {({ values, handleSubmit }) => (
              <Form>
                {initialValuesByPeriod && Object.keys(initialValuesByPeriod).sort((a, b) => b - a).map((persone, index) => {
                  return <RenderPriceBlock key={persone + index} persone={persone}
                                           expandedPrices={expandedPrices}
                                           priceLines={initialValuesByPeriod[persone]}
                                           updateInitValue={updateInitValue}
                                           updatePeriodPrice={updatePeriodPrice}
                                           removeTypeOfAllocation={removeTypeOfAllocation}
                                           handleChangeExpendedPrices={handleChangeExpendedPrices}
                                           closeAccordion={() => setExpandedPrices(false)}/>
                })}
              </Form>
            )}

          </Formik>


        </ModalChangeCalendar>


        <AddTypeOfAllocationModal open={open}
                                  onClose={handleCloseAddTypeOfAllocation}
                                  types={dontExistingAllocation}/>

        <StickyBottomButton action={() => toggleShowPriceModal(true)}
                            page="price"
                            disbaledBtn={channelManagerId}
                            btnText={`${startRangeDate ? startRangeDate.split("-").reverse().join(".") : ""}
                                             ${endRangeDate ? ' / ' : ""}
                                             ${endRangeDate ? endRangeDate.split("-").reverse().join(".") : ""} `}
                            titleText={roomName}/>

      </div>


    </>

  );
};


export default CalendarPercent;
